

























































































import { Vue, Component } from 'vue-property-decorator';

import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
import UmiaRoles from '@/components/Staff/UserManagement/Roles/UmiaRoles.vue';
import MmicRoles from '@/components/Staff/UserManagement/Roles/MmicRoles.vue';
import AmicRoles from '@/components/Staff/UserManagement/Roles/AmicRoles.vue';
import RrgRoles from '@/components/Staff/UserManagement/Roles/RrgRoles.vue';
import IctRoles from '@/components/Staff/UserManagement/Roles/InsureCareTeamsRoles.vue';

import Admin from '@/services/Admin';
import { UserInvite } from '@/common/Users';
import { required, email } from 'vuelidate/lib/validators';

@Component({
	name: 'StaffInviteUser',
	components: {
		Welcome,
		Alert,
		Loading,
		SelectField,
		TextField,
		Checkbox,
		UmiaRoles,
		MmicRoles,
		IctRoles,
		AmicRoles,
		RrgRoles,
	},
	validations: {
		user: {
			email: {
				email,
				required,
			},
			fullName: {
				required,
			},
		},
	},
})
export default class StaffInviteUser extends Vue {
	private isInvalid: boolean = false;
	private loading: boolean = false;
	private error: boolean = false;
	private success: boolean = false;
	private user: UserInvite = {
		fullName: '',
		email: '',
		policy_number: '',
		client_id: '',
		brand: 'mmic',
		permissions: {
			ACCOUNT_ADMIN: false,
			BILL_PAY: false,
			COVERAGE_TABLE: false,
			PAYMENT_HISTORY: false,
			REPORT_CLAIM: false,
			STAFF: false,
			VIEW_CLAIMS: false,
			VIEW_CME: false,
			VIEW_COI: false,
			VIEW_CYBER_SOLUTIONS: false,
			VIEW_LATEST_NEWS: false,
			VIEW_POLICY_INFO: false,
			VIEW_RISK_MANAGEMENT: false,
			VIEW_SAVED_QUOTES: false,
		},
	};

	private async inviteUsers() {
		this.isInvalid = false;
		this.success = false;
		this.error = false;

		if (!this.user.fullName || !this.user.email) {
			this.isInvalid = true;
			return;
		}
		this.loading = true;

		const users = [this.user];

		try {
			const inviteUsers = await Admin.inviteUsers(users);
			this.success = true;
			this.isInvalid = false;
		} catch (e) {
			this.error = e;
			this.success = false;
		} finally {
			this.loading = false;
			if (this.success) {
				this.user = {
					fullName: '',
					email: '',
					policy_number: '',
					client_id: '',
					brand: 'mmic',
					permissions: {
						ACCOUNT_ADMIN: false,
						BILL_PAY: false,
						COVERAGE_TABLE: false,
						PAYMENT_HISTORY: false,
						REPORT_CLAIM: false,
						STAFF: false,
						VIEW_CLAIMS: false,
						VIEW_CME: false,
						VIEW_COI: false,
						VIEW_CYBER_SOLUTIONS: false,
						VIEW_LATEST_NEWS: false,
						VIEW_POLICY_INFO: false,
						VIEW_RISK_MANAGEMENT: false,
						VIEW_SAVED_QUOTES: false,
					},
				};
			}
		}
	}
}
